const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    background,
    backgroundImg,
    hasMobileImage,
    backgroundImgMobile,
    fullHeight,
    margin,
  } = attributes;

  return (
    <section className={`MiddleBanner ${margin} ${background}`}>
      <picture
        className={`
          MiddleBanner-image-background
          ${!hasMobileImage ? 'MiddleBanner-image-background-desk' : ''}
          ${fullHeight ? 'MiddleBanner-image-background-full-height' : ''}
        `}
      >
        <source
          media="(min-width:768px)"
          srcset={backgroundImg.src}
          alt={backgroundImg.alt}
          title={backgroundImg.alt}
          height={backgroundImg.height}
          width={backgroundImg.width}
        />
        <img
          src={backgroundImgMobile.src}
          alt={backgroundImgMobile.alt}
          title={backgroundImgMobile.alt}
          height={backgroundImgMobile.height}
          width={backgroundImgMobile.width}
        />
      </picture>

      <div className="Container">
        <div className="MiddleBanner-content">
          <InnerBlocks.Content />
        </div>
      </div>
    </section>
  );
};

export default Save;
